import { render, staticRenderFns } from "./SVGEditor.vue?vue&type=template&id=fa0794a0&"
import script from "./SVGEditor.vue?vue&type=script&lang=js&"
export * from "./SVGEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports